import { baseApi } from './baseQuery'

export interface PaymentMethod {
    id: string
    last_four: string
    exp_month: number
    exp_year: number
    brand: string
    is_default: boolean
}

interface RetrieveLastPaymentMethodResponse {
    payment_method: PaymentMethod | null
}

export const paymentServiceApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        retrieveLastPaymentMethod: builder.query<PaymentMethod | null, { orderId: string }>({
            query: ({ orderId }) =>
                `/api/external/prescription_orders/${encodeURIComponent(orderId)}/previous_fill_payment_method`,
            transformResponse: (response: RetrieveLastPaymentMethodResponse) => response.payment_method,
            providesTags: (_result, _error, { orderId }) => [
                { type: 'PaymentMethods', id: `prescription-order-${orderId}` },
            ],
        }),
    }),
    overrideExisting: false,
})

export const { useRetrieveLastPaymentMethodQuery } = paymentServiceApi
